import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CompleteRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('completeRepaymentWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});
export type CompleteRepaymentWorkoutPlanEvent = z.infer<typeof CompleteRepaymentWorkoutPlanEvent>;
